import Button from "./Buttons/Button";
import { FaTimes } from "react-icons/fa";
import ReactDOM from "react-dom";
import { useEffect } from "react";
import classNames from "classnames";

interface ModalProps {
  title?: string;
  children?: React.ReactNode;
  close?: () => void;
  submit?: () => void;
  show: Boolean;
  size?: "md" | "lg";
}
const Modal = ({
  title,
  close,
  submit,
  show,
  size = "md",
  children,
}: ModalProps) => {
  const modalRoot = document.getElementById("modal-root");
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
      return;
    }
    document.body.style.overflow = "auto";
  }, [show]);

  const classes = classNames("bg-white rounded w-full", {
    "max-w-2xl": size === "md",
    "max-w-4xl": size === "lg",
  });

  if (!show || !modalRoot) return null;
  return ReactDOM.createPortal(
    <div className="fixed bg-modal z-50 w-full h-full top-0 left-0 top-0 overflow-y-auto overflow-x-hidden">
      <div className="flex justify-center my-16 mx-4 md:mx-0">
        <div className={classes}>
          <div className="flex justify-between border-b border-slate-300 p-2 md:px-4">
            <span>{title}</span>
            <Button size="medium" color="primary" inverted onClick={close}>
              <FaTimes className="text-slate-500" />
            </Button>
          </div>
          <div className="p-6 md:p-4">{children}</div>
          <div className="flex justify-between border-t border-slate-300 px-6 md:px-4 py-2">
            <Button size="medium" color="primary" onClick={submit}>
              Guardar
            </Button>
            <Button size="medium" color="primary" onClick={close} inverted>
              Cancelar
            </Button>
          </div>
        </div>
      </div>
    </div>,
    modalRoot,
  );
};

export default Modal;
